import { HubDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useConfirmationAction } from '../../../hooks/confirmation-action.hook';
import { useMutationTriggerBulkDataUpdate } from '../../hubs.queries';
import { ConfirmationModal } from '../../../../ui/components/pure/modal-content/confirmation-modal.component';

export function SyncHubDataModal({ hub, onAbort, onSuccess }: { hub: HubDto; onAbort(): void; onSuccess(): void }) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationTriggerBulkDataUpdate,
    mutationArgs: {
      hubID: hub.id
    },
    onSuccess,
    modalCloseDelay: 300
  });

  return (
    <ConfirmationModal
      title="Sync data"
      content={[
        "The data for this Hub (and it's Kiosks) will be synced. This process may take up to 5 minutes for all Kiosks to be fully updated.",
        'If the Kiosk is offline, the data will be synced once its connection is restored.'
      ]}
      noteRequired={false}
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Confirm',
        color: 'primary'
      }}
      cancelButton={{
        label: 'Cancel'
      }}
      {...state}
    />
  );
}
